/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Navbar megamenu - Open/close overlay
document.querySelectorAll('#navbar-desktop .dropdown-toggle').forEach(dropdown => {
    const init = () => {
        if (document.querySelector('#navbar-desktop .dropdown-menu.show')) {
            document.querySelector('#main').classList.add('main-hidden')
        } else {
            document.querySelector('#main').classList.remove('main-hidden')
        }
    }
    dropdown.addEventListener('shown.bs.dropdown', init)
    dropdown.addEventListener('hidden.bs.dropdown', init)
})

// Navbar megamenu - Hover trigger mode for parent menu items
document.querySelectorAll('#navbar-desktop.menu-desktop-hover .nav-item.dropdown').forEach(dropdown => {
    const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(dropdown.querySelector('.nav-link'))

    dropdown.addEventListener('mouseover', () => {
        document.querySelectorAll('#navbar-desktop.menu-desktop-hover .dropdown-menu').forEach(menu => {
            if (menu.previousElementSibling.dataset.index !== dropdown.querySelector('.nav-link').dataset.index) {
                menu.classList.remove('show')
            }
        })
        bsDropdown.show()
    })

    dropdown.addEventListener('mouseleave', () => {
        setTimeout(() => {
            if (!dropdown.matches(':hover')) {
                bsDropdown.hide()
            }
        }, 200)
    })
})

// Quantity steppers (plus/minus)
window.onClickQtyPlusMinus = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    if (btn.dataset.mode === 'plus') {
        input.value = inputValue + 1
    } else {
        if (input.value > Number(input.dataset.minQty)) {
            input.value = inputValue - 1
        }
    }

    const event = new Event('change')
    input.dispatchEvent(event)
}

// Share links using WebShare API
window.onLinkShare = (btn, e) => {
    if (navigator.share) {
        navigator.share({
            title: btn.dataset.shareTitle,
            url: window.location.href
        })
    } else {
        const popover = bootstrap.Popover.getOrCreateInstance(btn, {
            content: `
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" value="${window.location.href}">
                    <button id="btn-share-copy" class="btn btn-outline-secondary" type="button">${btn.dataset.textCopy}</button>
                </div>
            `,
            html: true,
            sanitize: false,
            placement: 'top'
        })

        popover.show()

        document.querySelector('#btn-share-copy')?.addEventListener('click', (e) => {
            navigator.clipboard.writeText(window.location.href)
            e.target.textContent = btn.dataset.textCopied
        })

        setTimeout(() => {
            popover.hide()
            btn.blur()
        }, 4000)
    }
}

// Search page - set selected value for the types select field
const initSearchPageSetSelected = () => {
    const select = document.querySelector('#search-header .form-select')

    if (!select) return

    const params = new URLSearchParams(location.search)
    const type = params.get('type')

    if (!type) return

    select.value = type
}
initSearchPageSetSelected()

// Countdown timers
const initCountdownTimers = () => {
    document.querySelectorAll('.countdown-timer').forEach((elem) => {
        if (elem.classList.contains('init')) return

        elem.classList.add('init')

        let end = Number(elem.dataset.time) * 1000

        if (window.location.href.includes('ecomify')) {
            end = Date.now() + 1.08e+7
        }

        const seconds = 1000
        const minutes = seconds * 60
        const hours = minutes * 60

        const x = setInterval(() => {
            const now = new Date().getTime()
            const difference = end - now

            if (difference < 0) {
                clearInterval(x)
                elem.remove()
                return
            }

            elem.removeAttribute('hidden')

            const h = Math.floor((difference) / hours)
            const m = Math.floor((difference % hours) / minutes)
            const s = Math.floor((difference % minutes) / seconds)

            elem.querySelector('[data-hours').innerText = `${h}${elem.dataset.textH}`
            elem.querySelector('[data-hours').setAttribute('aria-label', `${h} ${elem.dataset.textHours}`)
            elem.querySelector('[data-minutes').innerText = `${m}${elem.dataset.textM}`
            elem.querySelector('[data-minutes').setAttribute('aria-label', `${m} ${elem.dataset.textMinutes}`)
            elem.querySelector('[data-seconds').innerText = `${s}${elem.dataset.textS}`
            elem.querySelector('[data-seconds').setAttribute('aria-label', `${s} ${elem.dataset.textSeconds}`)

            if (h === 0) {
                elem.querySelector('[data-hours').setAttribute('hidden', 'hidden')
            }
        }, seconds)
    })
}
initCountdownTimers()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.countdown-timer')) {
        initCountdownTimers()
    }
})

/*
    Okendo Reviews Fixes
*/
const initOkendoFixes = () => {
    setTimeout(() => {
        const widget = document.querySelector('[data-oke-widget]')

        if (!widget) return

        const sortElem = widget.querySelector('#oke-sortSelect--reviews')
        sortElem.classList.add('form-select', 'form-select-md')

        const wrapper = document.createElement('div')
        wrapper.classList.add('form-select-wrapper')
        sortElem.parentNode.insertBefore(wrapper, sortElem)
        wrapper.appendChild(sortElem)
    }, 1500)
}
initOkendoFixes()

/*
    Get Okendo data from API
*/
const fetchOkendoDataFromApi = async () => {
    const res = await fetch('https://api.okendo.io/v1/stores/99fc98ab-59c5-40d1-9741-8014acee9878/review_aggregate')

    if (res.status === 200) {
        const data = await res.json()

        document.querySelectorAll('[data-okendo-total-reviews]').forEach(elem => {
            elem.textContent = data.reviewAggregate.reviewCount
        })

        document.querySelectorAll('[data-okendo-average-rating]').forEach(elem => {
            elem.textContent = (data.reviewAggregate.reviewRatingValuesTotal / data.reviewAggregate.reviewCount).toFixed(1)
        })
    }
}
fetchOkendoDataFromApi()

/*
    SMS Form through PostScript API
*/
const initSMSform = () => {
    const form = document.querySelector('#footer-sms-form')

    form?.addEventListener('submit', async (e) => {
        e.preventDefault()

        const input = form.querySelector('input[type="tel"]')
        // const btn = form.querySelector('button')

        form.style.opacity = '.2'

        const options = {
            method: 'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
                Authorization: `Bearer ${form.dataset.key}`
            },
            body: JSON.stringify({
                keyword: form.dataset.keyword,
                phone_number: input.value,
                origin: 'website'
            })
        }

        const response = await fetch('https://api.postscript.io/api/v2/subscribers', options)
        console.log(response)
        const data = await response.json()
        console.log(data)

        form.style.opacity = '1'

        if (data.errors) {
            form.querySelector('[data-sms-form-error').textContent = data.errors.at(-1).msg
            form.querySelector('[data-sms-form-success').textContent = ''
            form.querySelector('[data-sms-form-error').removeAttribute('hidden')
            form.querySelector('[data-sms-form-success').setAttribute('hidden', 'hidden')
        } else {
            form.querySelector('[data-sms-form-error').textContent = ''
            form.querySelector('[data-sms-form-success').textContent = 'Thank you for subscribing'
            form.querySelector('[data-sms-form-error').setAttribute('hidden', 'hidden')
            form.querySelector('[data-sms-form-success').setAttribute('hidden')
        }
    })
}
initSMSform()

// Easy Profile Editor
document.querySelectorAll('.ep-input-group .ep-input').forEach(input => {
    input.classList.remove('ep-input')
    input.classList.add('form-control')

    const wrapper = document.createElement('div')
    wrapper.classList.add('form-control-wrapper')
    input.parentNode.insertBefore(wrapper, input)
    wrapper.appendChild(input)
})

document.querySelectorAll('.ep-input-group .ep-input-btn').forEach(btn => {
    btn.classList.remove('ep-input-btn')
    btn.classList.add('btn', 'btn-primary', 'btn-styled')

    btn.insertAdjacentHTML('afterend', `
        <a href="javascript:history.go(-1)" class="btn btn-link mt-3">
            ← Back to account
        </a>
    `)
})
